import STORE from '../store';
import invalidateVisCache from './invalidateVisCache';

const createDashboardGadget = async (
  gadget: DashboardGadget,
  accountId: string,
) => {
  await STORE.visualisations
    .getDashboardGadgetsRef({ accountId })
    .doc(gadget.id)
    .set(gadget);

  await invalidateVisCache({
    accountId,
    changes: { dashboardGadgets: [gadget.id] },
  });
};

export default createDashboardGadget;
